import InputField from '../../../../components/InputField'
import Text from '../../../../components/Text'
import Button from '../../../../components/ButtonNew'

// icons
import CallIcon from '../../../../assets/icons/call-icon.svg'
import ArrowRightIcon from '../../../../assets/icons/common/arrow-right.svg'
import {
  TERMS_URL,
  POLICY_URL,
  NAME_LETTERS_AND_SPACES_PATTERN,
} from '../../../../constants'

const PhoneScreen = ({
  formObject,
  updateFormObject,
  handleOnSubmit,
  isLoading,
}) => {
  return (
    <div>
      {/* Section Header */}
      <div>
        <Text
          variant="headline"
          size="small"
          className="text-[#101828] mb-3"
          tag="h2"
        >
          Enter Mobile Number
        </Text>
        <Text
          variant="body"
          size="large"
          className="text-[#344054] mb-8"
          tag="p"
        >
          An OTP will be sent to the following number for verification
        </Text>
      </div>

      {/* Name Field */}
      <div className="space-y-4">
        <InputField
          label="Name"
          type="text"
          placeholder="Enter your name"
          value={formObject.name}
          autoFocus
          onChange={(event) => {
            const value = event.target.value
            if (NAME_LETTERS_AND_SPACES_PATTERN.test(value)) {
              updateFormObject('name', value)
            }
          }}
        />
        {/* Mobile Number Field */}
        <InputField
          label="Mobile Number"
          type="tel"
          maxLength={10}
          leftIcon={<img src={CallIcon} alt="ph" className="h-6 w-6" />}
          placeholder="Enter your mobile number"
          value={formObject.contactNo}
          onChange={(event) => {
            if (/^\d{0,10}$/.test(event.target.value)) {
              updateFormObject('contactNo', event.target.value)
            }
          }}
        />
      </div>

      <Text variant="body" size="small" className="text-[#667085] mt-4" tag="p">
        By signing up you agree to GoodFlip's{' '}
        <a
          href={TERMS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold underline"
        >
          Terms and Conditions
        </a>{' '}
        and{' '}
        <a
          href={POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold underline"
        >
          Privacy Policy
        </a>
      </Text>

      <div className="fixed bottom-0 left-0 right-0 p-4 min-w-sm max-w-lg mx-auto w-full">
        <Button
          size="xSmall"
          fullWidth
          onClick={handleOnSubmit}
          loading={isLoading}
          disabled={
            formObject?.contactNo?.length !== 10 ||
            formObject?.name?.length < 2 ||
            isLoading
          }
        >
          Continue <img src={ArrowRightIcon} />
        </Button>
      </div>
    </div>
  )
}

export default PhoneScreen
